import { Component, Inject, Input } from '@angular/core';
import { Reservation } from '../../api/model/reservation/reservation.model';
import { IAppState } from '../../store/interfaces/IAppState';
import { SiteURLUtils } from '../../common/site.url.utils';
import { redirectToURL } from '../../common/common';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../../api/config';
import { Hotel } from '../../api/model/hotel/hotel.model';

@Component({
  selector: 'modify-room',
  templateUrl: './modify-room.component.html',
  styleUrls: ['./modify-room.component.scss']
})
export class ModifyRoomComponent {
  @Input() isOpen: boolean;
  @Input() messages;
  @Input() reservation: Reservation;
  @Input() hotel: Hotel;
  state: IAppState;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) { }


  redirectToRoomPage() {
    redirectToURL(SiteURLUtils.getLocalizedChangeRoomUrl(this.appConfig, this.reservation, this.hotel));
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/modify-room/modify-room.component.ts